import React, {Component} from 'react';
import {Button, Container, Form, Grid, Icon, Message} from 'semantic-ui-react';
import socket from "../../functions/socket";
import update from "react-addons-update";
import CustomDivider from "../extras/CustomDivider";
import {showToast} from "../../actions/ToastAction";
import {connect} from "react-redux";
import localDB from "../../data/localDB";
import Loading from "../extras/Loading";

let sw = null;

class PrinterForm extends Component {
    constructor() {
        super();
        this.state = {
            type_print: [
                {key: '58mm', value:'58mm', text:'Tirilla de 58mm'},
                {key: '80mm', value:'80mm', text:'Tirilla de 80mm'},
            ],
            printers: [],
            data:{
                printer: null,
                paper: null
            },
            printer_error:false,
            paper_error:false,
            conected: false,
            connecting: true,
            loading: true
        }
    }

    componentDidMount() {
        this.connectSocket();
    }

    connectSocket = () =>{
        let data = localDB.get('print_settings');
        if(data){
            this.setState({data});
        }
        sw = socket.connect_printer();

        sw.onopen = () => {
            sw.send(JSON.stringify({type:'printers'}));
            this.setState({conected:true});
        };

        sw.onerror = (error) => {
            this.setState({conected:false, loading:false});
        };
        sw.onmessage = this.messageRecieved;
        this.setState({connecting:false});
    };

    messageRecieved = (event) =>{
        let data = JSON.parse(event.data);
        this.setState({loading:false});
        switch (data.type){
            case 'printers':
                this.setState({printers:data.printers});
                break;
            default:
                break;
        }
    };

    handleChange = (e, { name, value }) => {
        let data = update(this.state, {
            data: {
                [name]: {$set: value}
            }
        });
        this.setState(data);
        this.setState({printer_error:false, paper_error:false});
    };

    handleSubmit = () =>{
        this.setState({printer_error:false, paper_error:false});
        if(!this.state.data.printer){
            this.setState({printer_error:true});
        }else if(!this.state.data.paper){
            this.setState({paper_error:true});
        }else{
            localDB.set('printer_settings', this.state.data);
            this.props.showToast({type:'success', message:'Configuración exitosa!'});
        }
    };

    printDemo = () => {
        let printer_settings = localDB.get('printer_settings');
        if(printer_settings){
            sw.send(JSON.stringify({
                type:'demo',
                paper:printer_settings.paper,
                printer: printer_settings.printer
            }));
        }else{
            this.props.showToast({type:'error', message:'Primero marque la opción de Impresora Principal!'});
        }
    };

    render() {
        return (
            <div>
                {!this.state.loading ? <Container>
                    <Grid>
                        {this.state.conected ? <Grid.Row>
                            <Grid.Column>
                                <Form>
                                    <Form.Select
                                        noResultsMessage='No hay registros'
                                        label='Impresora'
                                        name='printer'
                                        options={this.state.printers}
                                        placeholder='Impresora'
                                        onChange={this.handleChange}
                                        value={this.state.data.printer}
                                        error={this.state.printer_error}
                                    />
                                    <Form.Select
                                        noResultsMessage='No hay registros'
                                        label='Tipo de Papel'
                                        name='paper'
                                        options={this.state.type_print}
                                        placeholder='Tipo de Papel'
                                        onChange={this.handleChange}
                                        value={this.state.data.paper}
                                        error={this.state.paper_error}
                                    />
                                    <Form.Field>
                                        <Button.Group fluid>
                                            <Button
                                                primary
                                                content='Configuración Principal'
                                                onClick={this.handleSubmit}
                                            />
                                            <Button.Or text=''/>
                                            <Button
                                                content="Imprimir Prueba"
                                                onClick={this.printDemo}
                                            />
                                        </Button.Group>
                                    </Form.Field>
                                </Form>
                            </Grid.Column>
                        </Grid.Row>:null}
                    </Grid>
                    {this.state.conected ? <CustomDivider/>:null}
                    {this.state.conected ?<Message
                        icon='warning'
                        header='Advertencia!'
                        content='Esta configuración es temporal, por lo tanto puede que se pierda y deba agregarla nuevamente.'
                    />:null}
                    {!this.state.conected ? <div style={{marginTop:50}}>
                        <Message icon>
                            <Icon name='warning sign' />
                            <Message.Content>
                                <Message.Header>Advertencia</Message.Header>
                                Para poder continuar abra la aplicación <strong><a href="https://io.bisttros.com/BisttrosIO.application">Bisttros IO</a></strong> o si aún no la tiene puede descargarla desde <a href="https://io.bisttros.com" target="_blank" rel="noopener noreferrer" ><strong>aquí</strong></a>.
                                <CustomDivider/>
                                <Button fluid loading={this.state.connecting} disabled={this.state.connecting} primary onClick={this.connectSocket} content="Conectar con Bisttros IO"/>
                            </Message.Content>
                        </Message>
                    </div>:null}
                </Container>:<Loading/>}
            </div>
        );
    }
}

function mapDispatchToProps(dispatch){
    return {
        showToast(toast){
            dispatch(showToast(toast));
        }
    }
}

export default connect(
    null,
    mapDispatchToProps
)(PrinterForm)




// WEBPACK FOOTER //
// ./src/components/printer/PrinterForm.js